module.exports = __webpack_public_path__ + "fonts/KaTeX_Main-Italic.fa675e5.ttf";